<template>
  <b-modal
    id="activity-modal"
    ref="activity-modal"
    :title="$t('title.updateActivityModal')"
    size="lg"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    :ok-title="$t('control.button.save')"
    :cancel-title="$t('control.button.cancel')"
    @ok="onSubmit"
  >
    <div class="row">
      <div class="col-md-12">
        <b-card
          border-variant="primary"
        >
          <div class="row">
            <div class="col-md-6">
              <b-card
                no-body
                header="Entities"
                header-bg-variant="primary"
                header-text-variant="white"
                border-variant="secondary"
                text-variant="secondary"
              >
                <draggable
                  class="list-group flush"
                  :list="filteredEntities"
                  group="entities"
                  style="max-height:450px;overflow:auto;"
                >
                  <div
                    v-for="(element) in filteredEntities"
                    :key="element.id"
                    class="list-group-item"
                  >
                    {{ element.name }}
                  </div>
                </draggable>
              </b-card>
            </div>
            <div class="col-md-6">
              <b-card
                no-body
                header="Selected Entities"
                header-bg-variant="primary"
                header-text-variant="white"
                border-variant="secondary"
                text-variant="secondary"
              >
                <draggable
                  class="list-group"
                  :list="selectedEntities"
                  group="entities"
                  style="max-height:450px;overflow:auto;"
                >
                  <div
                    v-for="(element) in selectedEntities"
                    :key="element.id"
                    class="list-group-item"
                  >
                    {{ element.name }}
                  </div>
                </draggable>
              </b-card>
            </div>
          </div>
        </b-card>`
      </div>
    </div>
  </b-modal>
</template>

<script>
import draggable from 'vuedraggable';
import entities from '../services/Entities';
import activities from '../services/Activities';

export default {
  components: {
    draggable,
  },
  data() {
    return {
      selectedEntities: [],
      entities: [],
      form: {
        id: 0,
      },
    };
  },
  computed: {
    filteredEntities() {
      if (this.entities == null || this.selectedEntities == null) return [];
      return this.entities.filter((item) => !this.selectedEntities.find((se) => Number(se.id) === Number(item.id)));
    },
  },
  mounted() {
    if (this.$store.getters['authorization/isAdministrator']) {
      this.getEntities();
      this.$root.$on('updateActivityModal', (activity) => {
        this.update(activity);
      });
    }
  },
  methods: {
    resetForm() {
      this.selectedEntities = [];
      this.form = {
        id: 0,
      };
    },
    onSubmit(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.$nextTick(async () => {
        activities.baseUrl = this.$store.state.settings.apiBaseUrl;
        if (this.$store.getters['authorization/data'] != null) activities.userId = this.$store.getters['authorization/data'].id;
        await activities.saveEntities(this.form.id, this.selectedEntities);
        this.closeModal();
      });
    },
    showModal() {
      this.getEntities();
      this.$bvModal.show('activity-modal');
    },
    closeModal() {
      this.$bvModal.hide('activity-modal');
    },
    update(activity) {
      this.form.id = activity.id;
      this.getActivityEntities(activity.id);
      this.showModal();
    },
    async getEntities() {
      entities.baseUrl = this.$store.state.settings.apiBaseUrl;
      const result = await entities.getEntities();
      this.$nextTick(() => {
        // eslint-disable-next-line prefer-destructuring
        this.entities = result[1];
      });
    },
    async getActivityEntities(id) {
      activities.baseUrl = this.$store.state.settings.apiBaseUrl;
      const result = await activities.getEntitiesForActivity(id);
      this.$nextTick(() => {
        // eslint-disable-next-line prefer-destructuring
        this.selectedEntities = result[1];
      });
    },
  },
};

</script>
